<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save()" [formGroup]="machineForm">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ (machine ? 'common.edit' : 'common.new') | translate }} {{ 'machines.machine' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.equipment-info.equipment' | translate }} #<i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="serialNumber" class="ir-form-set" type="text" formControlName="serialNumber" [readonly]="!!machine" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.equipment-info.product-line' | translate }}<i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input type="hidden" name="productLine" class="ir-form-set" formControlName="productLine" />
                <div class="ir-line ir-select th-select" (click)="openProductLinesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{ productLineSelected?.name ?? ('plugins.equipment-info.select-product-line' | translate) }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.equipment-info.equipment-type' | translate }}<i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input type="hidden" name="modelId" class="ir-form-set" formControlName="modelId" />
                <div class="ir-line ir-select th-select" (click)="openModelsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{ modelSelected?.name ?? ('plugins.equipment-info.select-machine' | translate) }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.equipment-info.customer-equipment-id' | translate }}</strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="clientSerialNumber" class="ir-form-set" type="text" formControlName="clientSerialNumber" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.equipment-info.equipment-year' | translate }}</strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="year" class="ir-form-set" type="number" formControlName="year" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="machineForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectModelsMenu($event)" #modelsModal></modal>
<modal (modalOutput)="selectProductLinesMenu($event)" #productLinesModal></modal>
